<template>
  <div>
    <div class="pdf-preview" v-if="pdfFile">
      <button @click.self="closePreview()">
        &times;
    </button>

    <iframe
      :src="pdfFile"
      width="100%"
      height="100%"
    />
    </div>
    <div v-show="false">
      <div ref="testHtml">
        <div v-for="page in totalPages" :key="page" class="mx-5 my-4">
          <div class="pdf-item d-flex text-xs justify-content-between">
            <div>
                  <img
                    src="../assets/gunter_Logo-bg.png"
                    alt="Logo"
                    style="flex: none;"
                    height="30"
                    width="30"
                  />
            </div>
            <div class="text-center">
                  <h4
                  class="text-xs"
                  >
                    GUNTER SHIPPING
                    <br/>
                    {{ response.exporterAddress.toUpperCase() }}
                    <br/>
                    {{ response.exporterCity.toUpperCase() }},
                    {{ response.exporterState.toUpperCase() }}
                    {{ response.exporterZipCode }}
                  </h4>
              </div>
              <div class="text-xs">
                  DOCK RECEIPT
              </div>
          </div>
          <div class="pdf-item">
            <table class="table text-xs w-100" style="line-height: 1;">
              <tr>
                <td class="bordered" style="border-left-style: hidden;" rowspan = "2">
                  <div class="smalltext font-weight-bold">
                    EXPORTER
                  </div>
                  <div>
                    {{ response.exporterFirstName.toUpperCase() }}
                    {{ response.exporterLastName.toUpperCase() }}
                    <br/>
                    {{ response.exporterAddress.toUpperCase() }}
                    <br/>
                    {{ response.exporterCity.toUpperCase() }},
                    {{ response.exporterState.toUpperCase() }}
                    {{ response.exporterZipCode }}
                    <br/>
                    Tel: {{ response.exporterPhone }}
                  </div>
                </td>
                <td class="bordered">
                  <div class="smalltext font-weight-bold ">
                    BL NUMBER
                  </div>
                  <div>
                    {{ response.billOfLading }}
                  </div>
                </td>
                <td  class="bordered" style="border-right-style: hidden;">
                  <div class="smalltext font-weight-bold ">
                    BOOKING NO.
                  </div>
                  <div>
                    {{ response.billOfLading }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-right-style: hidden;" colspan = "2">
                  <div class="smalltext font-weight-bold ">
                    EXPORTER REFERENCES
                  </div>
                  <div>
                    {{ response.exporterReference }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-left-style: hidden;" rowspan = "2">
                  <div class="smalltext font-weight-bold ">
                    CONSIGNED TO
                  </div>
                  <div>
                    {{ response.importerFirstName.toUpperCase() }}
                    {{ response.importerLastName.toUpperCase() }}
                    <br/>
                    {{ response.importerAddress.toUpperCase() }}
                    <br/>
                    {{ response.importerCity.toUpperCase() }},
                    {{ response.importerState.toUpperCase() }}
                    {{ response.importerZipCode }}
                    <br/>
                    Tel: {{ response.importerPhone }}
                  </div>
                </td>
                <td  class="bordered" style="border-right-style: hidden;" colspan = "2">
                  <div class="smalltext font-weight-bold ">
                    FORWARDING AGENT
                  </div>
                  <div>
                    {{ response.forwardingAgentFirstName.toUpperCase() }}
                    {{ response.forwardingAgentLastName.toUpperCase() }}
                    <br/>
                    {{ response.forwardingAgentAddress.toUpperCase() }}
                    <br/>
                    {{ response.forwardingAgentCity.toUpperCase() }},
                    {{ response.forwardingAgentState.toUpperCase() }}
                    {{ response.forwardingAgentZipCode }}
                    <br/>
                    Tel: {{ response.forwardingAgentPhone }}
                    <br/>
                    FMC: {{ response.forwardingAgentFmc.toUpperCase() }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-right-style: hidden;" colspan = "2">
                  <div class="smalltext font-weight-bold ">
                    POINT(STATE) OF ORIGIN OR FTZ NUMBER
                  </div>
                  <div>
                    {{ response.ftz.toUpperCase() }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-left-style: hidden;">
                  <div class="smalltext font-weight-bold ">
                    NOTIFY PARTY/INTERMEDIATE CONSIGNEE
                  </div>
                  <div>
                    {{ response.notifyPartyFirstName.toUpperCase() }}
                    {{ response.notifyPartyLastName.toUpperCase() }}
                    <br/>
                    {{ response.notifyPartyAddress.toUpperCase() }}
                    <br/>
                    {{ response.notifyPartyCity.toUpperCase() }},
                    {{ response.notifyPartyState.toUpperCase() }}
                    {{ response.notifyPartyZipCode }}
                    <br/>
                    Tel: {{ response.notifyPartyPhone }}
                  </div>
                </td>
                <td class="bordered" style="border-right-style: hidden;" colspan = "2">
                  <div>
                    {{ response.freightPaymentType.toUpperCase() }} - FILE {{ response.fileno }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-left-style: hidden;">
                  <div class="smalltext font-weight-bold ">
                    PRE-CARRIAGE BY
                  </div>
                  <div>
                    {{ response.preCarriage.toUpperCase() }}
                  </div>
                </td>
                <td class="bordered">
                  <div class="smalltext font-weight-bold ">
                    VESSEL/VOYAGE
                  </div>
                  <div>
                    {{ response.vessel.toUpperCase() }} {{ response.voyage.toUpperCase() }}
                  </div>
                </td>
                <td class="bordered" style="border-right-style: hidden;">
                  <div class="smalltext font-weight-bold ">
                    EXPORTING CARRIER
                  </div>
                  <div>
                    {{ response.exportingCarriage.toUpperCase() }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-left-style: hidden;">
                  <div class="smalltext font-weight-bold ">
                    PORT OF LOADING/EXPORT
                  </div>
                  <div>
                    {{ response.loadingPort.toUpperCase() }}
                  </div>
                </td>
                <td class="bordered" style="border-right-style: hidden;"  colspan = "2">
                  <div class="smalltext font-weight-bold ">
                    LOADING PIER/TERMINAL
                  </div>
                  <div>
                    {{ response.loadingPier.toUpperCase() }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="bordered" style="border-left-style: hidden;">
                  <div class="smalltext font-weight-bold ">
                    FOREIGN PORT OF UNLOADING
                  </div>
                  <div>
                    {{ response.unloadingPort.toUpperCase() }}
                  </div>
                </td>
                <td class="bordered">
                  <div class="smalltext font-weight-bold ">
                    PLACE OF DELIVERY BY ON-CARRIER
                  </div>
                  <div>
                    {{ response.destination.toUpperCase() }}
                  </div>
                </td>
                <td class="bordered" style="border-right-style: hidden;" colspan = "2">
                  <div class="smalltext font-weight-bold ">
                    TYPE OF MOVE
                  </div>
                  <div>
                    {{ deliveryType(response.deliveryType).toUpperCase() }}
                  </div>
                </td>
              </tr>
            </table>
            <table class="table text-xs w-100" style="line-height: 1;">
              <tr>
                <th class="bordered" style="border-left-style: hidden;" colspan="2">
                  CARRIER'S RECEIPT</th>
                <th class="bordered" style="border-right-style: hidden;" colspan="5">
                  PARTICULARS FURNISHED BY SHIPPER * CARRIER NOT RESPONSIBLE</th>
              </tr>
              <tr>
                <th class="bordered" style="border-left-style: hidden;">
                  MARKS AND NUMBERS</th>
                <th class="bordered">PACKAGES</th>
                <th colspan="3" width="50%" class="bordered">DESCRIPTION OF COMMODITIES</th>
                <th class="bordered">GROSS WEIGHT</th>
                <th class="bordered" style="border-right-style: hidden;">MEASUREMENT</th>
              </tr>
              <tr v-for="(item) in paginatedData(page-1)"
                :key="item.id">
                  <td class="bordered" style="border-bottom-style: hidden;
                  border-left-style: hidden;" height="80px">
                    {{ item.name }}
                    <br>
                    {{ item.containerType }}
                    <br>
                    SEAL: {{ item.containerSeal }}
                  </td>
                  <td class="bordered" style="border-bottom-style: hidden;"
                   height="80px">{{ containerQty(item.item)}}</td>
                  <td colspan="3" width="50%"
                   class="bordered" style="border-bottom-style: hidden;" height="80px">
                    {{ item.description }}</td>
                  <td class="bordered" height="80px" rowspan="2">
                    {{ containerWeight(item.item, 'lb') }} LBS
                    <br>
                    {{ containerWeight(item.item, 'kg') }} KGS
                  </td>
                  <td class="bordered" style="border-right-style: hidden;" height="80px"
                  rowspan="2">
                    {{ containerMeasurement(item.item, 'ft') }} CF
                    <br>
                    {{ containerMeasurement(item.item, 'm') }} M3
                  </td>
              </tr>
              <tr>
                <td class="bordered" style="border-left-style: hidden; border-bottom-style: hidden;
                border-top-style: hidden;"></td>
                <td class="bordered" style="border-bottom-style: hidden; border-top-style: hidden;">
                </td>
                <td colspan="3" width="50%"
                class="bordered" style="border-bottom-style: hidden; border-top-style: hidden;">
                  {{ response.freightRelease.toUpperCase() }} RELEASE AT DESTINATION
                </td>
              </tr>
              <tr>
                <td class="bordered" style=" border-left-style: hidden; border-bottom-style: hidden;
                 border-top-style: hidden;"></td>
                <td class="bordered" style="border-bottom-style: hidden; border-top-style: hidden;">
                </td>
                <th colspan="3" width="50%"
                class="text-right bordered" style="border-top-style: hidden;
                border-bottom-style: hidden;">
                  TOTALS
                </th>
                <th class="bordered" rowspan="2">
                  {{ totalWeight('lb') }} LBS
                  <br>
                  {{ totalWeight('kg') }} KGS
                </th>
                <th class="bordered" style="border-right-style: hidden;" rowspan="2">
                  {{ totalMeasurement('ft') }} CF
                  <br>
                  {{ totalMeasurement('m') }} M3
                </th>
              </tr>
              <tr>
                <td class="bordered" style=" border-left-style: hidden; border-top-style: hidden;">
                </td>
                <td class="bordered" style="border-top-style: hidden;"></td>
                <td colspan="3" width="50%" class="bordered" style="border-top-style: hidden;">
                  AES ITN# {{ response.aesITN.toUpperCase() }}
                </td>
              </tr>
            </table>
          </div>

          <div class="pdf-item mb-3 d-flex justify-content-between text-xs">
            <div>
              VESSEL: {{ response.vessel.toUpperCase() }}
              <br>
              VOYAGE: {{ response.voyage.toUpperCase() }}
              <br>
              ETD: {{ response.shippedDate }}
              <br>
              ETA: {{ response.arrivalDate }}
            </div>
          </div>
          <div v-if="page < totalPages" class="html2pdf__page-break" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';

export default {
  name: 'DockReceipt',
  props: [
    'name',
    'response',
    'currentUser',
  ],
  data() {
    return {
      pdfFile: null,
      seen: {},
      size: 1,
      deliveryTypes: [
        { value: 'porttoport', text: 'port to port' },
        { value: 'preclearance', text: 'pre-clearance' },
        { value: 'doortodoor', text: 'door to door' },
      ],
    };
  },
  computed: {
    totalPages() {
      const pages = Math.ceil(this.response.items.container.length / this.size);
      if (pages === 0) {
        return 1;
      }
      return pages;
    },
  },
  methods: {
    paginatedData(page) {
      const start = page * this.size;
      const end = start + this.size;
      const paginated = this.response.items.container.slice(start, end);
      while (paginated.length < this.size) {
        paginated.push({
          name: '',
          containerSize: '',
          containerLength: 0,
          containerWidth: 0,
          containerHeight: 0,
          containerSeal: '',
          selectedMeasureType: 'ft',
          item: [],
        });
      }
      return paginated;
    },
    currentDateTime() {
      const today = new Date();
      return today.toLocaleDateString('en-US');
      // need to update
    },
    containerQty(item) {
      return item.reduce(
        (accumulator, currentValue) => accumulator + currentValue.qty,
        0,
      );
    },
    containerWeight(item, type) {
      const weight = item.reduce(
        (accumulator, currentValue) => accumulator + currentValue.weight,
        0,
      );
      if (type === 'lb') {
        return parseFloat(weight).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(weight / 2.2046).toFixed(3).replace(/\.000$/, '');
    },
    containerMeasurement(item, type) {
      const volume = item.reduce(
        (accumulator, currentValue) => accumulator + currentValue.volume,
        0,
      );
      if (type === 'ft') {
        return parseFloat(volume / 1728).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(volume / 61023.7441).toFixed(3).replace(/\.000$/, '');
    },
    totalWeight(type) {
      let weight = 0;
      this.response.items.container.forEach((container) => {
        weight += container.item.reduce(
          (accumulator, currentValue) => accumulator + currentValue.weight,
          0,
        );
      });
      if (type === 'lb') {
        return parseFloat(weight).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(weight / 2.2046).toFixed(3).replace(/\.000$/, '');
    },
    totalMeasurement(type) {
      let volume = 0;
      this.response.items.container.forEach((container) => {
        volume += container.item.reduce(
          (accumulator, currentValue) => accumulator + currentValue.volume,
          0,
        );
      });
      if (type === 'ft') {
        return parseFloat(volume / 1728).toFixed(3).replace(/\.000$/, '');
      }
      return parseFloat(volume / 61023.7441).toFixed(3).replace(/\.000$/, '');
    },
    deliveryType(value) {
      const type = this.deliveryTypes.find((delivery) => delivery.value === value);
      if (type) {
        return type.text;
      }
      return '';
    },
    reset() {
      this.seen = {};
    },
    closePreview() {
      this.pdfFile = null;
    },
    generatePdf() {
      /* eslint new-cap: ["error", { "newIsCap": false }] */
      // const doc = new jsPDF('p', 'pt', 'A4');
      // const margins = {
      //   top: 80,
      //   bottom: 60,
      //   left: 40,
      //   width: 522,
      // };

      // doc.html(this.$refs.testHtml, { left: margins.left, width: margins.width }).then(() => {
      //   doc.output('dataurlnewwindow');
      // });
      const opt = {
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          dpi: 300,
          scale: 4,
        },
      };

      html2pdf().from(this.$refs.testHtml).set(opt).output('bloburl')
        .then((ref) => {
          this.pdfFile = ref;
        });
    },
  },
  filters: {
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
};
</script>

<style lang="scss" scoped>
 body {
  font-family: Helvetica;
}
li:not(:last-child) {
    // margin-bottom: 5px;
    margin-bottom: 1px;
}

.table {
  margin-bottom: -0.8px;
}

.table-bordered td, .table-bordered th {
  border: 1px solid #343434;
  padding-top: 0;
}

.heading {
  border-bottom: 1px solid #343434;
}

.bordered {
  border: 1px solid #343434;
  padding-top: 0;
}

.borderedLeft {
  border-left: 1px solid #343434
}

.smalltext {
  font-size: 0.55rem;
  line-height: 1rem;
}

.pdf-preview {
  position: fixed;
  width: 65%;
  min-width: 600px;
  height: 80vh;
  top: 100px;
  z-index: 9999999;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0px 0px 10px #00000048;

  button {
    position: absolute;
    top: -20px;
    left: -15px;
    width: 35px;
    height: 35px;
    background: #555;
    border: 0;
    box-shadow: 0px 0px 10px #00000048;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
  }

  iframe {
    border: 0;
  }

}

</style>
